import { css } from "styled-components";

import { blueGreyMui, greyMui } from "../declarations";
import { MOBILE_BREAKPOINT, rydeColors } from "../parts";

export const tableCellsStyles = css`
  .grid_table_cell {
    border-inline-start: none;
    border-top: 1px solid ${greyMui._300};
    padding: 6px;
    font-size: 14px;
    color: ${rydeColors.black};
  }

  .cell_simple {
    color: ${rydeColors.black};
    display: flex;
    align-items: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    > span {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    &.is_hidden {
      display: none;
    }
  }

  .cell_simple.cell_status_green {
    color: ${rydeColors.green};
  }

  .cell_simple.cell_status_red {
    color: ${rydeColors.darkerRed};
  }

  .multi_icon_cell {
    color: ${blueGreyMui._500};
    display: flex;
    align-items: center;
    line-height: 1px;
    margin-inline-start: 3px;
    svg {
      margin-inline-end: 11px;
    }
    @media (max-width: ${MOBILE_BREAKPOINT}) {
      svg.star_icon {
        margin-inline: 0;
      }
    }
  }
`;
